export default __webpack_public_path__ + "static/media/aWithd.9018c5cb.svg";